import { PROSUMER_PUBLIC_UPSELL_ROOT_PATH, ROUTES } from '../../routing';
import ProsumerDashboard from '../../pages/Dashboard/ProsumerDashboard';
import ProsumerActivity from '../../pages/Activity/ProsumerActivity';
import ProsumerProject from '../../pages/Project/ProsumerProject';
import ProsumerProjectsDashboard from '../../pages/ProjectsDashboard/ProsumerProjectsDashboard';
import { Redirect, Route } from 'react-router-dom';
import LearnModeOnlyRoute from '../../components/Routes/LearnModeOnlyRoute';
import AuthenticatedRoute from '../../components/Routes/AuthenticatedRoute';
import PaymentCallback from '../../pages/ProsumerPublicUpsell/PaymentCallback';
import ProsumerPublicUpsellRoute from '../../components/Routes/ProsumerPublicUpsellRoute';
import ProsumerPublicUpsellLearningPlan from '../../pages/ProsumerPublicUpsell/LearningPlan';
import ProsumerPublicUpsellBenefits from '../../pages/ProsumerPublicUpsell/Benefits';
import ProsumerPublicUpsellPayment from '../../pages/ProsumerPublicUpsell/Payment';
import ProsumerPublicUpsellPaymentCallback from '../../pages/ProsumerPublicUpsell/PaymentCallback';
import LearningPlanUpsell from '../../pages/ProsumerUpsell/LearningPlan';
import Payment from '../../pages/ProsumerUpsell/Payment';
import Benefits from '../../pages/ProsumerUpsell/Benefits';

export const PROSUMER_ROUTES = [
  <LearnModeOnlyRoute
    exact
    path={ROUTES.PROSUMER.MODULE_DASHBOARD.PATH}
    key={ROUTES.PROSUMER.MODULE_DASHBOARD.PATH}
  >
    <ProsumerDashboard />
  </LearnModeOnlyRoute>,
  <LearnModeOnlyRoute
    exact
    path={ROUTES.PROSUMER.ACTIVITY.PATH}
    key={ROUTES.PROSUMER.ACTIVITY.PATH}
  >
    <ProsumerActivity />
  </LearnModeOnlyRoute>,

  <LearnModeOnlyRoute
    exact
    path={ROUTES.PROSUMER.PROJECT.PATH}
    key={ROUTES.PROSUMER.PROJECT.PATH}
  >
    <ProsumerProject />
  </LearnModeOnlyRoute>,
  <AuthenticatedRoute
    path={ROUTES.PROSUMER.PROJECTS_DASHBOARD.PATH}
    key={ROUTES.PROSUMER.PROJECTS_DASHBOARD.PATH}
  >
    <ProsumerProjectsDashboard />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.PROSUMER.PAYMENT.PATH}
    key={ROUTES.PROSUMER.PAYMENT.PATH}
  >
    <Payment />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.PROSUMER.BENEFITS_UPSELL.PATH}
    key={ROUTES.PROSUMER.BENEFITS_UPSELL.PATH}
  >
    <Benefits />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.PROSUMER.PLAN_UPSELL.PATH}
    key={ROUTES.PROSUMER.PLAN_UPSELL.PATH}
  >
    <LearningPlanUpsell />
  </AuthenticatedRoute>,
  <AuthenticatedRoute
    exact
    path={ROUTES.PROSUMER.PAYMENT_CALLBACK.PATH}
    key={ROUTES.PROSUMER.PAYMENT_CALLBACK.PATH}
  >
    <PaymentCallback />
  </AuthenticatedRoute>,
];

export const PROSUMER_PUBLIC_UPSSELL_ROUTES = [
  <Route
    exact
    path={PROSUMER_PUBLIC_UPSELL_ROOT_PATH}
    key={PROSUMER_PUBLIC_UPSELL_ROOT_PATH}
  >
    <Redirect to={ROUTES.PROSUMER.PUBLIC_PLAN_UPSELL.PATH} />
  </Route>,
  <ProsumerPublicUpsellRoute
    exact
    path={ROUTES.PROSUMER.PUBLIC_PLAN_UPSELL.PATH}
    key={ROUTES.PROSUMER.PUBLIC_PLAN_UPSELL.PATH}
  >
    <ProsumerPublicUpsellLearningPlan />
  </ProsumerPublicUpsellRoute>,
  <ProsumerPublicUpsellRoute
    exact
    path={ROUTES.PROSUMER.PUBLIC_BENEFITS_UPSELL.PATH}
    key={ROUTES.PROSUMER.PUBLIC_BENEFITS_UPSELL.PATH}
  >
    <ProsumerPublicUpsellBenefits />
  </ProsumerPublicUpsellRoute>,
  <ProsumerPublicUpsellRoute
    exact
    path={ROUTES.PROSUMER.PUBLIC_PAYMENT.PATH}
    key={ROUTES.PROSUMER.PUBLIC_PAYMENT.PATH}
  >
    <ProsumerPublicUpsellPayment />
  </ProsumerPublicUpsellRoute>,
  <ProsumerPublicUpsellRoute
    exact
    path={ROUTES.PROSUMER.PUBLIC_PAYMENT_CALLBACK.PATH}
    needsUpsellData={false}
    key={ROUTES.PROSUMER.PUBLIC_PAYMENT_CALLBACK.PATH}
  >
    <ProsumerPublicUpsellPaymentCallback />
  </ProsumerPublicUpsellRoute>,
];
